import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { getCompleteTenders } from '../../lib/requests/routesRequests'
import { delays } from '../../lib/constants'
import { getCurrentLang, getToken, getDicionary } from '../selectors'

export function* worker({ data }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(getCompleteTenders, token, currentLang, data),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({
        type: 'SET_PAGE_COMPLETE_TENDERS',
        payload: result.data.data.page,
      })
      yield put({
        type: 'SET_TOTAL_COMPLETE_TENDERS',
        payload: result.data.data.total,
      })
      const list = result.data.data.routes.map((item) => item.periodic)
      if (list.length > 0) {
        yield put({
          type: 'SAGA_GET_TENDER_DETAILS',
          tenderList: list.toString(),
          typeAction: 'complete',
        })
      }
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({
      type: 'SET_API_ERROR',
      payload: true,
    })
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* routeForWidget() {
  yield takeEvery('SAGA_GET_COMPLETE_TENDERS', worker)
}
